var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.blob.giftcard.id,
    staticClass: "absolute-fill elevation-8 gc-border",
    class: {
      black: !_vm.placeholder
    }
  }, [_vm.placeholder ? _c('div', {
    staticClass: "absolute-fill grey gc-border loading-shimmer"
  }) : _vm._e(), _c('v-btn', _vm._g({
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "mt-n5 ml-n5",
    class: {
      clickable: !_vm.blob.giftcard.claim_id
    },
    style: {
      transform: `scale(${1 / _vm.scale}) rotate(${-_vm.blob.r}deg)`
    },
    attrs: {
      "absolute": "",
      "rounded": "",
      "dark": "",
      "color": _vm.blob.giftcard.claim_id ? 'grey lighten-1' : 'green lighten-2'
    }
  }, _vm.blob.giftcard.claim_id ? {} : {
    click: function () {
      return _vm.$emit('click');
    }
  }), [_c('currency', {
    attrs: {
      "code": _vm.blob.giftcard.cur
    }
  }), _vm._v(_vm._s(_vm.showValue ? _vm.blob.giftcard.amt : '') + " ")], 1), ['purchase', 'edit'].includes(_vm.mode) && !_vm.blob.giftcard.claim_id && _vm.showValue && !_vm.isVerifiedRecipient ? _c('div', {
    staticClass: "absolute d-flex justify-center clickable",
    staticStyle: {
      "width": "100%",
      "bottom": "-20px"
    },
    style: {
      transform: `scale(${1 / _vm.scale}) rotate(${-_vm.blob.r}deg)`
    }
  }, [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    attrs: {
      "rounded": "",
      "elevation": "6",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.mode == 'purchase' || _vm.blob.sample && _vm.isOwner ? 'Change merchant / amount…' : 'Add to gift card…') + " ")])], 1) : _vm._e(), _vm.blob.giftcard.product_img == 'https://cdn.ellacard.com/giftcards_gift_of_choice.jpg' ? _c('video', {
    staticClass: "user-select-none gc-border",
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "draggable": "false",
      "width": "100%",
      "poster": "//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.webp",
      "src": "//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.mp4"
    },
    domProps: {
      "muted": true
    },
    on: {
      "loadedmetadata": _vm.onLoad,
      "error": _vm.onLoad
    }
  }) : _c('img', {
    staticClass: "user-select-none gc-border",
    attrs: {
      "draggable": "false",
      "src": _vm.blob.giftcard.product_img
    },
    on: {
      "load": _vm.onLoad
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }